import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const date = searchParams.get('date') || new Date().toISOString().split('T')[0]

  // Cash-in clients du jour = paiements + avances STANDALONE (vente_id IS NULL).
  // Les transactions liées à une vente (vente_id renseigné) ne comptent PAS ici :
  // leur cash est déjà dans ventes.montant_encaisse → évite le double-comptage.
  const paiementsClients = await query<any>(`
    SELECT ct.id, ct.type, ct.montant, ct.note, ct.created_at, cl.name as client_name
    FROM client_transactions ct
    JOIN clients cl ON ct.client_id = cl.id
    WHERE cl.shop_id = ?
      AND ct.type IN ('paiement', 'avance')
      AND ct.vente_id IS NULL
      AND DATE(ct.created_at) = ?
    ORDER BY ct.created_at DESC
  `, [shopId, date])

  const totalPaiementsClients = paiementsClients.reduce((s: number, p: any) => s + parseFloat(p.montant), 0)

  const session = await queryOne<any>(`
    SELECT cs.*,
      COALESCE(SUM(v.montant_encaisse), 0) as total_ventes,
      COALESCE((SELECT SUM(r.montant) FROM retraits r WHERE r.caisse_session_id = cs.id), 0) as total_retraits,
      COALESCE((SELECT SUM(c.montant) FROM charges c WHERE c.caisse_session_id = cs.id), 0) as total_charges
    FROM caisse_sessions cs
    LEFT JOIN ventes v ON v.caisse_session_id = cs.id
    WHERE cs.shop_id = ? AND cs.date = ?
    GROUP BY cs.id
  `, [shopId, date])

  if (!session) {
    return NextResponse.json({
      session: null,
      paiements_clients: paiementsClients,
      total_paiements_clients: totalPaiementsClients,
    })
  }

  session.total_paiements_clients = totalPaiementsClients
  session.solde_theorique =
      parseFloat(session.solde_ouverture)
    + parseFloat(session.total_ventes)
    + totalPaiementsClients
    - parseFloat(session.total_retraits)
    - parseFloat(session.total_charges)

  const retraits = await query(
    'SELECT * FROM retraits WHERE caisse_session_id = ? ORDER BY created_at DESC',
    [session.id]
  )
  const charges = await query(
    'SELECT * FROM charges WHERE caisse_session_id = ? ORDER BY created_at DESC',
    [session.id]
  )

  return NextResponse.json({ session, retraits, charges, paiements_clients: paiementsClients })
}

export async function POST(req: Request) {
  const { shop_id, user_id, solde_ouverture } = await req.json()
  const date = new Date().toISOString().split('T')[0]

  // Réouvre une session existante du jour si déjà créée par une vente
  const existing = await queryOne<any>(
    'SELECT id FROM caisse_sessions WHERE shop_id = ? AND date = ?',
    [shop_id, date]
  )
  if (existing) {
    await query(
      'UPDATE caisse_sessions SET solde_ouverture = ?, statut = ?, ferme_a = NULL, solde_reel = NULL WHERE id = ?',
      [solde_ouverture || 0, 'ouverte', existing.id]
    )
    return NextResponse.json({ id: existing.id })
  }

  const id = uuid()
  await query(
    'INSERT INTO caisse_sessions (id, shop_id, user_id, date, solde_ouverture, statut) VALUES (?, ?, ?, ?, ?, ?)',
    [id, shop_id, user_id, date, solde_ouverture || 0, 'ouverte']
  )
  return NextResponse.json({ id })
}
